var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher",class:{'on': _vm.val},on:{"click":_vm.change}},[_c('div',{staticClass:"center-line"}),_vm._v(" "),_c('div',{staticClass:"switch-circle"}),_vm._v(" "),_c('div',{staticClass:"click-area"})])
}
var staticRenderFns = []

export { render, staticRenderFns }